module.exports = __webpack_public_path__ + "img/avanza-pais.195fd810.png";